import React from 'react';
import './FeatureCard.css';

function FeatureCard({ title, description, image }) {
  return (
    <div className="feature-card">
      {image && <img src={image} alt={title} className="feature-image" />}
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  );
}

export default FeatureCard;